import { getATLContextDomain } from '@atlassian/atl-context';
import { createAri } from '@atlassian/jira-platform-ari';
import type { Group } from '../types';

const MAGIC_PUBLIC_ANYONE_GROUP_UUID = '00000000-0000-0000-0000-000000000000';
const USER_BROWSER_URL = '/secure/admin/user/UserBrowser.jspa';

export const isPublicGroupId = (groupId: string) => groupId === MAGIC_PUBLIC_ANYONE_GROUP_UUID;
export const isPublicGroup = (group: Group) => isPublicGroupId(group.groupId);

export const getIdPHost = () => `https://${getATLContextDomain('admin')}`;
export const getGroupUrl = (orgId: string | undefined | null, group: Group) => {
	const host = getIdPHost();
	return orgId ? `${host}/o/${orgId}/groups/${group.groupId}` : undefined;
};

export const getGroupAri = (groupId: string) =>
	createAri({ resourceOwner: 'identity', resourceType: 'group', resourceId: groupId });

export const getUsersUrl = (orgId: string | undefined | null) => {
	const host = getIdPHost();
	return orgId ? `${host}/o/${orgId}/users?status=ACTIVE` : undefined;
};

export const getLegacyGroupUrl = (group: Group) => `${USER_BROWSER_URL}?group=${group.name}`;

export const getLegacyUsersUrl = () => USER_BROWSER_URL;
